module.exports = __webpack_public_path__ + "img/card2.b12217eb.png";